/**
 * @generated SignedSource<<1f155cc497fa90b4794ae38d3843f8b6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ComplexLink_complexLink$data = {
  readonly text: string | null | undefined;
  readonly title: string;
  readonly url: string;
  readonly " $fragmentType": "ComplexLink_complexLink";
};
export type ComplexLink_complexLink$key = {
  readonly " $data"?: ComplexLink_complexLink$data;
  readonly " $fragmentSpreads": FragmentRefs<"ComplexLink_complexLink">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ComplexLink_complexLink",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "text",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "url",
      "storageKey": null
    }
  ],
  "type": "ComplexLink",
  "abstractKey": null
};

(node as any).hash = "5f8d1e428e5149c7a0d3c865059d540c";

export default node;
